@use "../../styles/breakpoint.module.scss" as *;

.inner {
    composes: gridContainer from "../../styles/composable/layout.module.css";
    padding-block: var(--spacer-104);
}

.title {
    font: var(--font-h-48);
    color: var(--off-white);
}

.articles {
    grid-column: 4 / span 6;
    font: var(--font-h-24);

    @media ($below-tablet) {
        grid-column: 3 / span 8;
    }

    @media ($below-mobile) {
        grid-column: 1 / span 4;
    }
}

.articles {
    > *:last-child {
        margin-bottom: 0;
    }
}
